<script lang="ts">
  import { button } from '$components/ui/button.svelte';
  import { storyblokEditable } from '$lib/actions/storyblok-editable';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { ImageWithCtaStoryblok } from '$types/bloks';
  import { onMount } from 'svelte';
  import ResponsiveImage from './responsive-image.svelte';
  import { zoomOnScrollHandler } from '$lib/transitions';
  import { reducedMotion } from '$lib/stores/reduced-motion';

  export let content: ImageWithCtaStoryblok;
  let scale = 1;
  let imageContainer: HTMLAnchorElement;

  onMount(() => {
    if (content.slight_zoom_on_scroll && !$reducedMotion) {
      const handler = () => {
        zoomOnScrollHandler(imageContainer, (n) => (scale = n));
      };
      window.addEventListener('scroll', handler);
      return () => window.removeEventListener('scroll', handler);
    }
  });

  $: ({ href, rel, target } = !!content.cta?.[0] && $getAnchorFromCmsLink(content.cta[0].link));
</script>

{#if content.image?.[0] && content.cta?.[0]}
  <div use:storyblokEditable={content} class="py-2 lg:py-8" style:--scale={scale}>
    <a
      {href}
      {rel}
      {target}
      bind:this={imageContainer}
      class="block relative [&:focus-visible_img]:ring outline-0 border-0 overflow-hidden rounded-md"
    >
      <ResponsiveImage
        image={content.image[0]}
        class="w-full"
        imgClass="object-cover rounded-md w-full min-h-[560px] max-h-[560px] shadow-none motion-safe:transition-shadow scale-[var(--scale)]"
      />
      <div
        class={cn(
          button({ variant: 'secondary', size: 'md' }),
          'backdrop-blur absolute bottom-4 left-4 right-4 lg:right-[unset]'
        )}
      >
        {content.cta[0]?.label}
      </div>
    </a>
  </div>
{/if}
